export const COORDINATOR = "coordinator";
export const REPRESENTATIVE = "representative";
export const PARTICIPANT = "participant";
export const TEAM_ADMIN = "admin";

export const daysToSymbols: Record<string, string> = {
  monday: "M",
  tuesday: "T",
  wednesday: "W",
  thursday: "T",
  friday: "F",
  saturday: "S",
  sunday: "S",
};
